import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import enUS from 'antd/locale/en_US';
import viVN from 'antd/locale/vi_VN';

const localeMap: Record<string, any> = {
  en: enUS,
  vn: viVN,
};

export const useAntdLocale = () => {
  const { i18n } = useTranslation();

  const antdLocale = useMemo(() => {
    return localeMap[i18n.language] || enUS;
  }, [i18n.language]);

  return antdLocale;
};
